import { useEffect, useState } from 'react';
import { translateText, isEnglishCode, getLanguageLabel } from '../utils/translate';

export default function TranslatedText({ text, targetLang, className = '' }) {
  const [translated, setTranslated] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!text || isEnglishCode(targetLang)) {
      setTranslated('');
      setLoading(false);
      setError(false);
      return;
    }
    const run = async () => {
      setLoading(true);
      setError(false);
      try {
        const t = await translateText(text, targetLang);
        if (!cancelled) setTranslated(t);
      } catch (err) {
        console.error('TranslatedText:', err);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [text, targetLang]);

  if (isEnglishCode(targetLang) || !text) {
    return <span className={className}>{text}</span>;
  }

  if (loading) {
    return (
      <span className={className}>
        {text}
        <span className="ml-1 text-[10px] italic opacity-60">(translating to {getLanguageLabel(targetLang)}…)</span>
      </span>
    );
  }

  if (error || !translated) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={className}>
      {translated}
      <span className="ml-1 text-[10px] italic opacity-60">({getLanguageLabel(targetLang)})</span>
    </span>
  );
}
